
var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));  
//window.location.href = `${window.location.href}?product_url=${wizardInfo.setting_product_handle}`;

if(window.location.href.indexOf('?') > -1 && window.location.href.indexOf('product_url') < 0){
var last_path = window.location.href.split('?')[1];
  var path = `?${last_path}&product_url=${wizardInfo.setting_product_handle}`;
}else if( window.location.href.indexOf('product_url') < 0){
var path = `?product_url=${wizardInfo.setting_product_handle}`;
}
if(wizardInfo != null){
var url = `https://api-cdn.yotpo.com/v1/widget/L9klGXqDM8ftTtmrfrRqv0CC3aArk0IAPQQ1dJVC/products/7811807019144/reviews.json`
fetch(url)
        .then(response => response.json())
        .then(data => {
            productImages = data;
          if(productImages.response.bottomline.total_reviews > 0){
            if(productImages.response.bottomline.average_score > 0 && productImages.response.bottomline.average_score <1){
             $('a.ir218-stars.ir218-stars-small').css('background-position','left -12px');
            }else if(productImages.response.bottomline.average_score == 1){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -26px');
            }
            else if(productImages.response.bottomline.average_score > 1 && productImages.response.bottomline.average_score <2){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -39px');
            }
            else if(productImages.response.bottomline.average_score  == 2 ){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -52px');
            }
            else if(productImages.response.bottomline.average_score > 2 && productImages.response.bottomline.average_score < 3){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -66px');
            }
            else if(productImages.response.bottomline.average_score = 3){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -78px');
            }
            else if(productImages.response.bottomline.average_score > 3 && productImages.response.bottomline.average_score < 4){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -91px');
            }
            else if(productImages.response.bottomline.average_score = 4){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -103px');
            }
            else if(productImages.response.bottomline.average_score > 4 && productImages.response.bottomline.average_score < 5){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -117px');
            }
            else if(productImages.response.bottomline.average_score = 5){
              $('a.ir218-stars.ir218-stars-small').css('background-position','left -129px');
            }
  $('.reviews-badgets .ir218-write-read a').html(`(${productImages.response.bottomline.total_reviews})`)
          }else{
            $('.reviews-badgets').hide();
          }
        })
}
function toCurrencyFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits:2, maximumFractionDigits: 2});
}

function toNumberFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"decimal", minimumFractionDigits:2, maximumFractionDigits: 2});
}

function resetbackgroundColorSelected(){
  document.getElementById('select-size').getElementsByClassName('select-size-1')[0].style.backgroundColor = "transparent";  
  document.getElementById('select-size').getElementsByClassName('select-size-1')[1].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[2].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[3].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[4].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[5].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[6].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[7].style.backgroundColor = "transparent";
  document.getElementById('select-size').getElementsByClassName('select-size-1')[8].style.backgroundColor = "transparent"; 
  document.getElementById('select-size').getElementsByClassName('select-size-1')[9].style.backgroundColor = "transparent"; 
  
}

function allImage(){   
  

    fetch("https://my-solitaire.myshopify.com/assets", {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},            
    }).then(response => {
          console.log('response',response);  
        })
        .catch(error => console.error('Error:', error)); 

    
}

// Calculate Greatest Common Divisor
function gcd(a, b) {
    if (b === 0) {
      return a;
    }
    return gcd(b, a % b);
  }
  
  // Convert a decimal number to a simplified fraction
  function decimalToFraction(decimal) {
    const integerPart = Math.floor(decimal);
    let fractionPart = decimal - integerPart;
  
    // Define the precision for converting the fraction part
    const precision = 1000000;
    
    let numerator = Math.round(fractionPart * precision);
    let denominator = precision;
  
    // Simplify the fraction
    const commonDivisor = gcd(numerator, denominator);
    numerator /= commonDivisor;
    denominator /= commonDivisor;
  
    // Construct the output string
    let output = '';
    if (integerPart !== 0) {
      output += integerPart;
    }
  
    if (numerator !== 0) {
      if (integerPart !== 0) {
        output += ' ';
      }
      output += `${numerator}/${denominator}`;
    }
  
    if (integerPart === 0 && numerator === 0) {
      output = '0';
    }
  
    return output;
  }


function ResetImgs (){   
    let  imgNum = 1;  
    let img;
    for (let index = 0; index < 10; index++) {
        img=document.getElementById("diamond-img"+imgNum); 
        img.classList.remove('img-diamond-picture');  
        img.getElementsByTagName('img')[0].src="";   
        imgNum=imgNum+1; 
    }
}

function loadUrlImages(){
    let imgs = [
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_5.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_6_-_copia_2.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_3_-_copia_2.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_2.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_2_-_copia_2.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_3.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_2_-_copia_1.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_2_-_copia_3.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4_-_copia_-_copia.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_3_-_copia.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_5_-_copia.png?v=1665590060",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_1.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_6_-_copia.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
        "https://cdn.shopify.com/s/files/1/0591/3663/9116/files/size_4.png?v=1665590059",
    ];  

    return imgs;

}

async function createProductObject(diamond_id){    
    let url = window.API_URL +`diamonds/apiservices/new_api/${diamond_id}`;   
    let producto;
    var product = await fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json','X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM'},            
    }).then(res => res.json())
     .then(async product => {    
     producto = product;
     }).catch(error => console.error('Error:', error));   
  
   return producto;
}

async function existProduct(diamond_id){ 
  let url = window.API_URL +`diamonds/apiservices/new_api/${diamond_id}`; 
  let diamond;
  var result = await fetch(url, {
        method: 'GET',
        headers: {'Content-Type': 'application/json','X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM'},            
    }).then(res => res.json())
     .then(async result => {          
       diamond = result;
   }).catch(error => console.error('Error:', error));    
    return diamond;

}

async function createProductFinish(btnText,sInt){


  let infoRing = JSON.parse(localStorage.getItem('wizardInfo'));   

  let diamondProduct= await existProduct(infoRing.stone_id);


  if (diamondProduct.shopify_product_id == null) {
     let newProduct = await createProductObject(infoRing.stone_id);  // creo un producto     
   
  }

  let url1 = window.API_URL +`diamonds/apiservices/new_api/ring`;  
  let finishProduct;
 
  
  settingVariantId = infoRing.setting_variant_id?infoRing.setting_variant_id:41138478645384;

  
  let editMode = localStorage.getItem('editMode');
  // if(editMode !== null){
  //   let removalUrl = window.localStorage.getItem('urlToRemove');
  //   fetch(removalUrl, {
  //       method: 'POST',
  //       headers: {'Content-Type': 'application/json'},
  //       body: JSON.stringify({quantity: 0})
  //   }).then(response => {
  //       window.localStorage.removeItem('editMode');
  //       window.localStorage.removeItem('urlToRemove');
  //       window.localStorage.removeItem('wizardStart');
  //       window.localStorage.removeItem('latestSearch');
  //       fetch(url, {
  //           method: 'POST',
  //           body: JSON.stringify({
  //             "diamond_id":infoRing.stone_id,
  //             "variant_id":infoRing.setting_variant_id
  //           }),
  //           headers: { 'Content-type': 'application/json'}
  //       }).then(res => res.json())
  //           .then(product => {    
  //               console.log('product', product);    
  //             addCart(product);
  //           })
  //           .catch(error => console.error('Error:', error));
  //           }
  //       )
  // }
 // else {
 var settingImage=infoRing.setting_image_url;
  var accent_stone_val = '';
  let ring_band_product = JSON.parse(localStorage.getItem('ring_band_product'));
  if(ring_band_product != null && ring_band_product != undefined){
  let ring_product_id = ring_band_product.ring_product_id;
  let ring_product_vaiant_sku = ring_band_product.ring_product_vaiant_sku;
  let stone_shape = infoRing.stone_shape.toLocaleLowerCase();
  let selected_metal = infoRing.setting_selected_metal.toLocaleLowerCase().replace(/ /g,'');
    settingImage = `https://dsv7iunirnrax.cloudfront.net/${ring_product_id}/dyor_setting_${ring_product_vaiant_sku}_${stone_shape}_1_${selected_metal}-1.jpg`
  }
  var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
var stone_carat = parseFloat(wizardInfo.stone_carat);
var greater_no  = 0;
var frection_no =0;
var obj = JSON.parse($('.dyor_obj').attr('data-obj'));

for(i=0;i<obj.sizes.values.length;i++){
    
    var carat_val = parseFloat(obj.sizes.values[i].value);
    if(stone_carat <= carat_val){
        greater_no = carat_val
        frection_no = obj.sizes.values[i].key
         break;
    }
   
   
}
  if($('.accent_stone_val[data-carat="'+frection_no+'"][data-shape="'+wizardInfo.stone_shape+'"]').length > 0){
  accent_stone_val = $('.accent_stone_val[data-carat="'+frection_no+'"][data-shape="'+wizardInfo.stone_shape+'"]').html();
  }else{
    accent_stone_val = $('.accent_stone_val[data-carat="1"][data-shape="'+wizardInfo.stone_shape+'"]').html();
  }

  if(infoRing.setting_image_url == undefined || infoRing.setting_image_url == null){
    settingImage='';
  }
  fetch(url1, {
        method: 'POST',
        body: JSON.stringify({
          "diamond_id":infoRing.stone_id,
          "variant_id":infoRing.setting_variant_id,
          "product_image":settingImage,
          "cad_no":infoRing.setting_cad_no,
          "center_stone":infoRing.setting_center_stone,
          "accent_stone_val":accent_stone_val
        }),
        headers: { 'Content-type': 'application/json','X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json())
        .then(product => {   
   
          addCart(product,btnText,sInt);
        })
        .catch(error => console.error('Error:', error));

//}
}

function addCart(product,btnText,sInt){ 


  let currentCurrency = Shopify.currency.active;
  let currentCurrencySymbol = $('body').attr('data-currency');
  let currentRate = window.Shopify.currency.rate;
  let infoRing = JSON.parse(localStorage.getItem('wizardInfo')); 
 
  let band_products = localStorage.getItem('band_products');
  let selectSize = document.getElementById('select-size');
  let selectedSize =  selectSize.options[selectSize.selectedIndex].value; 
  let _band_products ;
  let items_band_products =[]; 
 if(band_products != null && $('.band_product_varinats .band_product').length >0){
    let dyor_metal = infoRing.setting_selected_metal;
    var handle = band_products.split(',')[1];
    var combine_variant = `${dyor_metal} / ${selectedSize}`
    if($('.band_product_varinats .band_product').length >1){
      $('.band_product_varinats .band_product').each(function(index){
      var size_variant =  $(this).find('.main_selector option').attr('data-size');
      var p_id = '';
       if(size_variant == 'true'){
         p_id = $(this).find('.main_selector option[data-title="'+combine_variant+'"]').attr('data-id')
         }else{
         p_id = $(this).find('.main_selector option[data-title="'+dyor_metal+'"]').attr('data-id')
       }
       let items_band = {};
       items_band ["id"] = parseInt(p_id);
       items_band["quantity"] =1;
       items_band_products.push(items_band);
       })
      }else if($('.band_product_varinats .band_product').length == 1){
      var p_id = '';
       var size_variant =  $('.band_product_varinats .main_selector option').attr('data-size');
       if(size_variant == 'true'){
         p_id = parseInt($('.band_product_varinats .main_selector option[data-title="'+combine_variant+'"]').attr('data-id'));
         }else{
         p_id = parseInt($('.band_product_varinats .main_selector option[data-title="'+dyor_metal+'"]').attr('data-id'));
       }
      
      items_band_products.push({'id':p_id,'quantity':1});
    }
    _band_products = `${band_products}`
    }
  if(band_products != null){
     _band_products = `${band_products}`
  }
  let deliver_date = $('#deliverydate').text().replace(",", ".");
  let ring_band_product = JSON.parse(localStorage.getItem('ring_band_product'));
  let selectImage = infoRing.setting_image_url;
  let selectProductname = infoRing.setting_product_name;
  if(ring_band_product != null && ring_band_product != undefined){
  let ring_product_id = ring_band_product.ring_product_id;
  let ring_product_vaiant_sku = ring_band_product.ring_product_vaiant_sku;
  let stone_shape = infoRing.stone_shape.toLocaleLowerCase();
  let selected_metal = infoRing.setting_selected_metal.toLocaleLowerCase().replace(/ /g,'');
    selectImage = `https://dsv7iunirnrax.cloudfront.net/${ring_product_id}/dyor_setting_${ring_product_vaiant_sku}_${stone_shape}_1_${selected_metal}-1.jpg`
    selectProductname = ring_band_product.ring_product_title;
    infoRing.setting_product_handle = ring_band_product.ring_product_handle;
    infoRing.setting_product_name = ring_band_product.ring_product_title;
  }
  let carat_list =localStorage.getItem('product_carat_value1');
  let id = parseInt(product.variants[0].id);
  let pid = infoRing.setting_variant_id;
  let ppid = infoRing.setting_product_id;
  let selectVariantPrice= infoRing.setting_variant_price;
  let stoneCarat = infoRing.stone_carat;
  let stoneClarity = infoRing.stone_clarity;
  let stoneColor = infoRing.stone_color;
  let stoneCut = infoRing.stone_cut;
  let stoneDelivery = $('#deliverydate').text().replace(",", ".");
  let stoneImage = infoRing.stone_image_url;
  let stonePrice = infoRing.stone_price;
  let stoneShape = infoRing.stone_shape;
  let allowedSize = infoRing.setting_allowed_ring_sizes;
  let certificate_number = infoRing.stone_certificate_no;
  let certificate_type = infoRing.stone_certificate_type;
  let vendor_name = infoRing.stone_vendor_name;
  let diamond_type_new = 'Lab Grown';
  infoRing.final_deliver = $('#deliverydate').text().replace(",", ".");
  let items = [];
        
  localStorage.setItem('wizardInfo',JSON.stringify(infoRing));
  let wizardInfo = JSON.stringify(localStorage.getItem('wizardInfo'));
  let wizardStart = localStorage.getItem('wizardStart');
    items.push({'id': id ,'quantity': 1,properties: {'Size': selectedSize, '_wizardInfo': wizardInfo, '_wizardStart': wizardStart, '_allowedSize':allowedSize, '_pdid':ppid, '_pid': pid, '_selectVariantPrice':selectVariantPrice, '_image': selectImage, '_pname': selectProductname, '_stoneClarity': stoneClarity, '_stoneColor': stoneColor, '_stoneCut':stoneCut, '_stoneCarat': stoneCarat, '_stoneDelivery': stoneDelivery,'_deliver_date': deliver_date, '_stoneImage':stoneImage,'_stonePrice':stonePrice, '_stoneShape':stoneShape,'_diamond_type_new':diamond_type_new,'_carat_list':carat_list,'_vendor_name':vendor_name,'_certificate_type':certificate_type,'_certificate_number':certificate_number,_band_products  }});
        let body = {
        "items": items
        }
  fetch((window.Shopify.routes.root +"cart/add.js"), {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)       
    }).then(response => { 
          clearInterval(sInt);
          $('#diamond-with-setting').html(btnText)
          let url = window.Shopify.routes.root+"cart";
         var complete_ring_step = localStorage.getItem("complete_ring_step");
        var diamond_step = localStorage.getItem("diamond_page_step");
        if(complete_ring_step != null){
          window.localStorage.removeItem('complete_ring_step');
        }
        if(diamond_step != null){
          window.localStorage.removeItem('diamond_page_step');
        }
   
        if(band_products != null){
         
        $.ajax({
         type: 'POST',
         url: '/cart/add.js',
         data:  { items: items_band_products},
         async:false,
         dataType: 'json',
         success: function (data) { 
         } 
         });
      } 
      
          localStorage.setItem('Product_Added',true);
       window.location.href = url;  
        })
        .catch(error => console.error('Error:', error)); 

}

function bindEventsAddCart(){
  let btnText = null;
 
  
   document.getElementById('diamond-with-setting').addEventListener('click', event => {
    var default_selected_val = $('#select-size').find(":selected").val();
    if(default_selected_val == 'default'){
    $('#selected_value_error').show();
    }else{
    
    // Change the innerHTML property with a list of sentences
    let messages = ['Please wait...','Crafting your diamond....','Crafting your setting...','Almost there...'];
    let spinner = ` <svg class="tw-w-10 tw-h-10" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
    <g fill="none" fill-rule="evenodd">
        <g transform="translate(1 1)" stroke-width="2">
            <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
            <path d="M36 18c0-9.94-8.06-18-18-18">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 18 18"
                    to="360 18 18"
                    dur="1s"
                    repeatCount="indefinite"/>
            </path>
        </g>
    </g>
</svg>`;
    btnText = event.target.innerHTML;
     
    let sInt = setInterval(function(){
        let random = Math.floor(Math.random() * messages.length);
        event.target.innerHTML = spinner + " "+ messages[random];
    }, 1000);

     let infoRing = JSON.parse(localStorage.getItem('wizardInfo'));
     let url = window.API_URL +`diamonds/apiservices/new_api/${infoRing.stone_id}`; 

     
     fetch(url, {
        method: 'GET',        
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
     }).then(res => res.json())
      .then(async diamond => {
        if(diamond && diamond.Diamond_ID) {
         
          createProductFinish(btnText,sInt);
          
        } else {
          clearInterval(sInt);
          event.target.innerHTML = btnText;
          $('body').append("<div id='stock-modal'><div onclick='$(this).parent().remove();' class='stock-modal-close'>X</div>We're so sorry the diamond you selected is no longer available, please choose another before placing your order.</div>");
        }
          
      })
      .catch(error => console.error('Error:', error));
     }
    });
  
}

function bindEventsSelectSize(sizeDefault){
    let button = document.getElementById('button-select'); 
    document.querySelectorAll('#select-size > .select-size-1').forEach((opciones)=>{
        opciones.addEventListener('click',(e)=>{
           
            let valor =e.currentTarget.getElementsByTagName('h2')[0].innerHTML; 
            let imgs = loadUrlImages();            
            let img;
            let imgsFilter=[];
            let imgNum = 1;
           


        });
   });  
}

function bindEvents() {   
    //bindEventsSelectSize();
    bindEventsAddCart();
}
let ring_band_product = JSON.parse(localStorage.getItem('ring_band_product'));
var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
if(ring_band_product != null && wizardInfo != null){
  wizardInfo.setting_product_handle = ring_band_product.band_and_ring_handle;
  wizardInfo.setting_product_name = ring_band_product.band_and_ring_title;
  localStorage.setItem('wizardInfo',JSON.stringify(wizardInfo));
}
var purpose ='get_carat_val'

if(wizardInfo != null){
  if(wizardInfo.stone_id == null){
  localStorage.removeItem("wizardStart")
  window.location.href=window.location.origin;
  }
   var diamond_id = wizardInfo.stone_id;
   var handle = wizardInfo.setting_product_handle;
   getProductImage(handle,purpose);
   var img_url =wizardInfo.setting_image_url;
   var pd_sku =wizardInfo.setting_variant_sku;
   if(ring_band_product != null ){
   pd_sku = ring_band_product.band_and_ring_sku
   }
   var p_id =wizardInfo.setting_product_id;
   var ston_shap =wizardInfo.setting_selected_shape.toLocaleLowerCase();
  var stone_shape_360 =wizardInfo.stone_shape.toLocaleLowerCase();
   var carat_val_deci = 0;
   var carat_val_2 =1/2;
   var carat_val_3 = '1/2';
   var carat_val_4;
   var carat_val ;
   var setting_selected_metal=wizardInfo.setting_selected_metal.toLowerCase().replace(/[^a-z0-9]+/g, '').replace(/-$/, '').replace(/^-/, '');
  var setting_video_count=localStorage.getItem('setting_video_count');
  
   var product_carat_value1 =localStorage.getItem('product_carat_value1');
   if(product_carat_value1 == undefined || product_carat_value1 == null  ){
    product_carat_value1 =  $('.catar_uploded_image').attr('data-obj');
   }
    var carat_size =wizardInfo.stone_carat;
    var flag =0;
    var flag1 = 0;
  if(product_carat_value1 != null){
    var carart_val = product_carat_value1
    var carat_val1 = carart_val.split(",");
    
    $(carat_val1).each(function(index,e){
    carat_val_2=e.split("|")[1];
    carat_val_2= _.replace(carat_val_2, "/","-");
          var carat_val_deci=parseFloat(this.split("|")[0]);
          if(carat_val_deci != ''){
          if(carat_val_deci == carat_size){
             change_url = 'false';
          }
            if(carat_val_deci <= carat_size && flag1 == 0){
              carat_val_3 = carat_val_2;
              flag =1;
            }else if(carat_val_deci >= carat_size && flag == 0){
              flag1 = 1
              carat_val_3 = carat_val_2;
            }
          }
          });
      
          var sku = `dyor_setting_${pd_sku}`
         
          if(carat_val_3.indexOf('-') > -1){
          if(carat_val_3.length >3){
            var position = 1
            carat_val_4 = [carat_val_3.slice(0, position), carat_val_3.slice(position)].join(' ');
            carat_val=carat_val_4.replace('-','/');
            }else{
            carat_val=carat_val_3.replace('-','/');
           }
           }else{
            carat_val = carat_val_3;
         }
          var aws_img =false;
          var new_360url_check = `https://dsv7iunirnrax.cloudfront.net/360/${p_id}/${pd_sku}_${wizardInfo.stone_shape.toLocaleLowerCase()}_${carat_val_3}_${setting_selected_metal}-4/frame01.png`
          var new_360_url =  `${pd_sku}_${wizardInfo.stone_shape.toLocaleLowerCase()}_${carat_val_3}_${setting_selected_metal}-`
          var new_url = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${wizardInfo.stone_shape.toLocaleLowerCase()}_${carat_val_3}_${setting_selected_metal}`
         if( p_id == 7431068811400){
          var new_url_check = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${wizardInfo.stone_shape.toLocaleLowerCase()}_${carat_val_3}_${setting_selected_metal}_1.jpg`
         }else{
           var new_url_check = `https://dsv7iunirnrax.cloudfront.net/${p_id}/${sku}_${wizardInfo.stone_shape.toLocaleLowerCase()}_${carat_val_3}_${setting_selected_metal}-1.jpg`
         }
         checkImageExists(new_360url_check, function(exists) {
           var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
           var handle = wizardInfo.setting_product_handle;
           if (exists) {
              var purpose_video = 'get_aws_video'
             getProductImage(handle,purpose_video,new_360url_check,p_id,new_360_url);
           }else{
            var purpose_video= 'get_video'
            getProductImage(handle,purpose_video);
            
            }
             })
         checkImageExists(new_url_check, function(exists) {
         
           var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
           if (exists) {
              var purpose = 'get_aws_img'
              if(wizardInfo != null){
                var handle = wizardInfo.setting_product_handle;
              }
              getProductImage(handle,purpose,new_url,p_id,new_360_url);
            }else{
           if(wizardInfo != null || wizardInfo != undefined){
            var handle = wizardInfo.setting_product_handle;
            var purpose= 'get_img'
            getProductImage(handle,purpose);
            }
            }
             })
    }else{
  var wizardInfo = JSON.parse(localStorage.getItem("wizardInfo"));
   if(wizardInfo != null || wizardInfo != undefined){
    var handle = wizardInfo.setting_product_handle;
    var purpose= 'get_img'
    getProductImage(handle,purpose)
    }
    }
}else{
  localStorage.removeItem("wizardStart")
  window.location.href=window.location.origin;
}
function getProductImage(handle,purpose,img_url,p_id,new_360_url) {
var custom_text_360 = localStorage.getItem('custom_text');
var custom_sku_360 = localStorage.getItem('custom_sku');  
  var purpose = purpose;
  
  $.ajax({
    url: `/products/${handle}?view=dyor-setting&variant=${wizardInfo.setting_variant_id}`,
    type: 'GET',
    success: function(res) {
     var vendor = $(res).find('.product.product--large').attr('data-vendor');
      let qntymore = $(res).find('.get_attr_main').attr('data-quantity_more');
      let qntyless = $(res).find('.get_attr_main').attr('data-quantity_less');
      let inventory_qty = $(res).find('.get_attr_main').attr('data-inventory_qty');
      let vprice = $(res).find('.get_attr_main').attr('data-vprice');
      if(purpose == 'get_carat_val'){
      transprancy_pricing(res);
      calcDeliveryDate(inventory_qty,qntymore,qntyless,vprice);
      var product_carat =  parseFloat($(res).find('.product.product--stacked').attr('data-carat-size'));
      var stone_carat =   parseFloat(wizardInfo.stone_carat);
      var total_carat_size = product_carat+stone_carat;
       total_carat_size = total_carat_size.toFixed(2);
        
        if(!isNaN(total_carat_size)){
      $('#ring-short-detail').html(`Your total diamond weight is ${total_carat_size} carats of diamonds`);
        }
        var p_url = $(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+wizardInfo.setting_variant_id+'"]').attr('data-url');
          var p_idd = $(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+wizardInfo.setting_variant_id+'"]').attr('data-pdid');
          var v_id = wizardInfo.setting_variant_id;
         $('.swym-add-to-wishlist-view-product').attr({"data-product-id":p_id,"data-variant-id":v_id,"data-product-url":p_url}).addClass(`product_${p_idd}`);
         document.dispatchEvent(new  CustomEvent("swym:completeRing-loaded"));
      }  
       if(purpose == 'get_img'){
         var count =0;
        var no_img = parseInt($(res).find('.product__media-list li').length);
        
        $(res).find('.product__media-list li').each(function(index,ele){
            if($(this).find('deferred-media').length >0){
              count= count+1;
               var aria_label =$(this).find('deferred-media video').attr('aria-label');
              var video_src =  $(this).find('deferred-media video source').attr('src');
                var poster_img = $(this).find('deferred-media video img').attr('src');
             $(`#grid-img-diamond #diamond-img${index+3},div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<video playsinline="playsinline" controls="controls" autoplay="autoplay" loop="loop" preload="none" muted="muted" aria-label='' poster='' src=${video_src}><source src=${video_src} type="video/mp4"><img src='${poster_img}'></video>`)
             }else{
            var Img_src = $(this).find('.product__modal-opener .product__media img').attr('src');
    
                if(Img_src != undefined){
               if(index == 0){
                 count= count+1;
            $(`#grid-img-diamond #diamond-img1 ,div#carouselExampleIndicators .carousel-inner .diamond-img1`).html(`<img src=${Img_src} alt="">`);
              }else if(index >= 1){
                 count= count+1;
                 $(`#grid-img-diamond #diamond-img${index+3} ,div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<img src=${Img_src} alt="">`);
              }
                }
            }
        });
          myVar = setInterval( informUser, 100);
              function informUser(){
                if(count == no_img){
                  $('.carousel-inner .product-diamond-images').each(function(){
                  if ($(this).is(':empty')) {
                     $(this).remove(); 
                  }
                  })
                  $('.carousel .carousel-inner').slick({dots:true,arrows:true})
                  clearInterval(myVar);
                }
              }
       } 
       if(purpose == 'get_aws_img'){
         wizardInfo = JSON.parse(localStorage.getItem('wizardInfo')); 
          var count1 =0;
        var no_img = parseInt($(res).find('.product__media-list li.media_replace').length);
        $(res).find('.product__media-list li.media_replace').each(function(index,ele){
            if($(this).find('deferred-media').length >0){
             
              count1= count1+1;
              if( p_id == 7431068811400){
                 var video_url = `${img_url}_${index+1}.mp4`;
                $(`#grid-img-diamond #diamond-img${index+3},div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<video playsinline="playsinline" controls="controls" autoplay="autoplay" loop="loop" preload="none" muted="muted" aria-label='' poster='' src='${video_url}'><source src='${video_url}' type="video/mp4"><img src=''></video>`)
               
              }else{
                
             $.ajax({
              url: 'https://truesaniti.com/api/index2.php',
              type: 'POST',
              data: {
                sku: pd_sku,
                shape:stone_shape_360,
                carat:carat_val_3,
                pid:p_id,
                metal:setting_selected_metal,
                vcount:setting_video_count
               
              },
              success: function(data) {
           var data360_new = data;
            const parts = data360_new.split('_');
              if (parts.length >= 3) {
                
                  const desiredSubstring = parts[2];
                 var $text_360 = 'Shown with '+desiredSubstring.replace('-','/')+' Carat '+stone_shape_360+' Diamond';
               }
                 
                if(data == ""){
                     var count =0;
            var no_img = parseInt($(res).find('.product__media-list li').length);
           
            $(res).find('.product__media-list li').each(function(index,ele){
            if($(this).find('deferred-media').length >0){
              count= count+1;
               var aria_label =$(this).find('deferred-media video').attr('aria-label');
              var video_src =  $(this).find('deferred-media video source').attr('src');
                var poster_img = $(this).find('deferred-media video img').attr('src');
             
             $(`#grid-img-diamond #diamond-img${index+3},div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<video playsinline="playsinline" controls="controls" autoplay="autoplay" loop="loop" preload="none" muted="muted" aria-label='' poster='' src=${video_src}><source src=${video_src} type="video/mp4"><img src='${poster_img}'></video>`)
             }
             });
                } else{
                 var media_name_video = 'https://truesaniti.com/360/index.php?pid='+p_id+'&sku=' + data360_new + (index+1); 
                 
                $(`#grid-img-diamond #diamond-img${index+3},div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<div class="carat_shape_size"> <iframe class="360_frame" src="${media_name_video}" frameborder="0" scrolling="no" sandbox="allow-scripts allow-popups allow-same-origin" 
              name="sandbox"  width="100%" height="100%"></iframe><p class="size_shape_carat_jtpl">${$text_360}
              <svg class="ctsm-360" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 122.88 65.79" style="enable-background:new 0 0 122.88 65.79" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M13.37,31.32c-22.23,12.2,37.65,19.61,51.14,19.49v-7.44l11.21,11.2L64.51,65.79v-6.97 C37.4,59.85-26.41,42.4,11.97,27.92c0.36,1.13,0.8,2.2,1.3,3.2L13.37,31.32L13.37,31.32z M108.36,8.31c0-2.61,0.47-4.44,1.41-5.48 c0.94-1.04,2.37-1.56,4.3-1.56c0.92,0,1.69,0.12,2.28,0.34c0.59,0.23,1.08,0.52,1.45,0.89c0.38,0.36,0.67,0.75,0.89,1.15 c0.22,0.4,0.39,0.87,0.52,1.41c0.26,1.02,0.38,2.09,0.38,3.21c0,2.49-0.42,4.32-1.27,5.47c-0.84,1.15-2.29,1.73-4.36,1.73 c-1.15,0-2.09-0.19-2.8-0.55c-0.71-0.37-1.3-0.91-1.75-1.62c-0.33-0.51-0.59-1.2-0.77-2.07C108.45,10.34,108.36,9.38,108.36,8.31 L108.36,8.31z M26.47,10.49l-9-1.6c0.75-2.86,2.18-5.06,4.31-6.59C23.9,0.77,26.91,0,30.8,0c4.47,0,7.69,0.83,9.69,2.5 c1.99,1.67,2.98,3.77,2.98,6.29c0,1.48-0.41,2.82-1.21,4.01c-0.81,1.2-2.02,2.25-3.65,3.15c1.32,0.33,2.34,0.71,3.03,1.15 c1.14,0.7,2.02,1.63,2.65,2.77c0.63,1.15,0.95,2.51,0.95,4.1c0,2-0.52,3.91-1.56,5.75c-1.05,1.83-2.55,3.24-4.51,4.23 c-1.96,0.99-4.54,1.48-7.74,1.48c-3.11,0-5.57-0.37-7.36-1.1c-1.8-0.73-3.28-1.8-4.44-3.22c-1.16-1.41-2.05-3.19-2.67-5.33 l9.53-1.27c0.38,1.92,0.95,3.26,1.74,4.01c0.78,0.74,1.78,1.12,3,1.12c1.27,0,2.33-0.47,3.18-1.4c0.85-0.93,1.27-2.18,1.27-3.74 c0-1.59-0.41-2.82-1.22-3.69c-0.81-0.87-1.92-1.31-3.32-1.31c-0.74,0-1.77,0.18-3.07,0.56l0.49-6.81c0.52,0.08,0.93,0.12,1.22,0.12 c1.23,0,2.26-0.4,3.08-1.19c0.82-0.79,1.24-1.72,1.24-2.81c0-1.05-0.31-1.88-0.93-2.49c-0.62-0.62-1.48-0.93-2.55-0.93 c-1.12,0-2.02,0.34-2.72,1.01C27.19,7.62,26.72,8.8,26.47,10.49L26.47,10.49z M75.15,8.27l-9.48,1.16 c-0.25-1.32-0.66-2.24-1.24-2.78c-0.59-0.54-1.31-0.81-2.16-0.81c-1.54,0-2.74,0.77-3.59,2.33c-0.62,1.13-1.09,3.52-1.38,7.19 c1.14-1.16,2.31-2.01,3.5-2.56c1.2-0.55,2.59-0.83,4.16-0.83c3.06,0,5.64,1.09,7.75,3.27c2.11,2.19,3.17,4.96,3.17,8.31 c0,2.26-0.53,4.32-1.6,6.2c-1.07,1.87-2.55,3.29-4.44,4.25c-1.9,0.96-4.27,1.44-7.13,1.44c-3.43,0-6.18-0.58-8.25-1.76 c-2.07-1.17-3.73-3.03-4.97-5.59c-1.24-2.56-1.86-5.95-1.86-10.18c0-6.18,1.3-10.71,3.91-13.59C54.13,1.44,57.74,0,62.36,0 c2.73,0,4.88,0.31,6.46,0.94c1.58,0.63,2.9,1.56,3.94,2.76C73.81,4.92,74.61,6.44,75.15,8.27L75.15,8.27z M57.62,23.55 c0,1.86,0.47,3.31,1.4,4.36c0.94,1.05,2.08,1.58,3.44,1.58c1.25,0,2.3-0.48,3.14-1.43c0.84-0.95,1.26-2.37,1.26-4.26 c0-1.93-0.44-3.41-1.31-4.42c-0.88-1.01-1.96-1.52-3.26-1.52c-1.32,0-2.44,0.49-3.34,1.48C58.06,20.32,57.62,21.72,57.62,23.55 L57.62,23.55z M77.91,17.57c0-6.51,1.17-11.07,3.52-13.67C83.77,1.3,87.35,0,92.14,0c2.31,0,4.2,0.29,5.68,0.85 c1.48,0.57,2.69,1.31,3.62,2.22c0.94,0.91,1.68,1.87,2.21,2.87c0.54,1.01,0.97,2.18,1.3,3.52c0.64,2.55,0.96,5.22,0.96,8 c0,6.22-1.05,10.76-3.16,13.64c-2.1,2.88-5.72,4.32-10.87,4.32c-2.88,0-5.21-0.46-6.99-1.38c-1.78-0.92-3.23-2.27-4.37-4.05 c-0.82-1.26-1.47-2.98-1.93-5.17C78.14,22.64,77.91,20.22,77.91,17.57L77.91,17.57z M87.34,17.59c0,4.36,0.38,7.34,1.16,8.94 c0.77,1.6,1.89,2.39,3.36,2.39c0.97,0,1.8-0.34,2.51-1.01c0.71-0.68,1.23-1.76,1.56-3.22c0.34-1.47,0.5-3.75,0.5-6.85 c0-4.55-0.38-7.6-1.16-9.18c-0.77-1.56-1.93-2.35-3.47-2.35c-1.58,0-2.71,0.8-3.42,2.39C87.69,10.31,87.34,13.27,87.34,17.59 L87.34,17.59z M112.14,8.32c0,1.75,0.15,2.94,0.46,3.58c0.31,0.64,0.76,0.96,1.35,0.96c0.39,0,0.72-0.13,1.01-0.41 c0.28-0.27,0.49-0.7,0.63-1.29c0.13-0.59,0.2-1.5,0.2-2.74c0-1.82-0.15-3.05-0.46-3.68c-0.31-0.63-0.77-0.94-1.39-0.94 c-0.63,0-1.09,0.32-1.37,0.96C112.28,5.4,112.14,6.59,112.14,8.32L112.14,8.32z M109.3,30.23c10.56,5.37,8.04,12.99-10.66,17.62 c-5.3,1.31-11.29,2.5-17.86,2.99v6.05c7.31-0.51,14.11-2.19,20.06-3.63c28.12-6.81,27.14-18.97,9.36-25.83 C109.95,28.42,109.65,29.35,109.3,30.23L109.3,30.23z"></path></g></svg> </p> </div>`)
                var height = $('#diamond-img5').height();
                $('#diamond-img6 .carat_shape_size').css('height',`${height}px`);
                }
                }
                });   
                }
              }else{
               if( p_id == 7431068811400){
               var Img_src = `${img_url}_${index+1}.jpg`;
               }else{
               var Img_src = `${img_url}-${index+1}.jpg`;  
               }
               if(index == 0){
                 count1= count1+1;
              wizardInfo.setting_image_url = Img_src
              localStorage.setItem('wizardInfo',JSON.stringify(wizardInfo));
              $(`#grid-img-diamond #diamond-img1 ,div#carouselExampleIndicators .carousel-inner .diamond-img1`).html(`<img src=${Img_src} alt="">`);
              }else if(index >0){
                 count1= count1+1;
                 $(`#grid-img-diamond #diamond-img${index+3} ,div#carouselExampleIndicators .carousel-inner .diamond-img${index+3}`).html(`<img src=${Img_src} alt="">`);
              }
              
            }
        });
          myVar = setInterval( informUser, 100);
              function informUser(){
                if(count1 == no_img){
                  $('.carousel-inner .product-diamond-images').each(function(){
                  if ($(this).is(':empty')) {
                     $(this).remove(); 
                  }
                  })
                  $('.carousel .carousel-inner').slick({dots:true,arrows:true})
                  clearInterval(myVar);
                }
              }
         
       }
    }
});
}
function diamind_data() {
  return new Promise((resolve) => {
 var diamond_id = wizardInfo.stone_id
    url = window.API_URL +`diamonds/apiservices/new_api/${diamond_id}`;
     fetch(url, {
        method: 'GET',        
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json()).then(async diamond => {
      resolve(diamond);
    })
  });
}
function getProductdata (handle){
return new Promise((resolve1) => {
 $.ajax({
    url: `https://truesanity.com/products/${handle}?view=inventory`,
    type: 'GET',
    success: function(res) {
      resolve1(res);
    }
});
})
}
async function transprancy_pricing(res){
const result = await diamind_data();
if($(res).find('.Jewelry-data').length >0){
if($(res).find('.Jewelry-data h2').length >0){
$('div#tab-4 .fst_tab_cnt_lft').show();
$('div#tab-4 .fst_tab_cnt_lft').append($(res).find('.Jewelry-data h2'));
}
if($(res).find('.Jewelry-data .descrption').length >0){
$('div#tab-4 .fst_tab_cnt_lft').append($(res).find('.Jewelry-data .descrption'));
}
  if($(res).find('.Jewelry-data .boxes .box').length >0){
$('div#tab-4 .fst_tab_cnt_rgt .box-wrap').append($(res).find('.Jewelry-data .boxes').html());
  }
}
if($(res).find('.product_pricing_component').length >0){
$('a#pricing_tab').hide();
$('div#tab-1').hide();
var variant_id  = wizardInfo.setting_variant_id; 
var creativity_cost = $(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+variant_id+'"]').attr('data-creativity-cost');
var component_ring_price = $(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+variant_id+'"]').attr('data-component-price');
var crafting_cost = $(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+variant_id+'"]').attr('data-crafting-cost');
var packaging_cost = $(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+variant_id+'"]').attr('data-packaging-cost');
var duties_freight_cost = $(res).find('.product_pricing_component .product_transprancy_pricing[data-id="'+variant_id+'"]').attr('data-duties-freight-cost');
$('div#tab-1 .creativity_cost span.count').attr('data-count',creativity_cost);
$('div#tab-1 .crafting_cost span.count').attr('data-count',crafting_cost);
$('div#tab-1 .packaging_cost span.count').attr('data-count',packaging_cost);
$('div#tab-1 .duties_freight span.count').attr('data-count',duties_freight_cost);
var ring_price = parseFloat(wizardInfo.setting_variant_price/100);
component_ring_price = parseFloat(component_ring_price)
var stone_price = parseFloat(result.rapent_price)
var Total_main_price = (ring_price+stone_price).toFixed(2);
var component_price = stone_price+component_ring_price;
if(!isNaN(component_price)){
$('div#tab-1 .components_cost span.count').attr('data-count',component_price);
$('div#tab-1 .left-side-sct .main_price').text(Total_main_price);
}
var total_cost = parseFloat(creativity_cost)+parseFloat(crafting_cost)+parseFloat(packaging_cost)+parseFloat(duties_freight_cost)+parseFloat(component_price);
var credit_price = (parseFloat(creativity_cost)+parseFloat(crafting_cost)+parseFloat(packaging_cost)+parseFloat(duties_freight_cost)+parseFloat(component_price)*2.9)/100;
credit_price = credit_price + 0.3
if(!isNaN(credit_price)){
$('.credit_card span.count').attr('data-count',credit_price);
}
var total_cost_point = total_cost.toFixed(2);
total_cost = total_cost+credit_price;
var retail_price = (total_cost*3).toFixed(2);
if(!isNaN(retail_price)){
$('.right-side-sct .main_price').text(retail_price);
}
if(!isNaN(total_cost_point)){
$('.main_total_price span.count.percent').attr('data-count',total_cost_point);
  
} 
var total_compmain_cost = (Total_main_price - total_cost_point)/10;
if(Total_main_price > total_cost){
  if(total_compmain_cost > 230){
    $('.left-side-sct span.main-progress').css('height','230px')
  }else{
    $('.left-side-sct span.main-progress').css('height',total_compmain_cost+'px')
  }
}
  var total_retailcomp_cost = (retail_price-total_cost)/10;
  var total_div = total_cost /10;
  if(retail_price > total_cost){
    if(total_retailcomp_cost > 230){
      $('.right-side-sct span.main-progress').css('height','230px')
    }else{
   $('.right-side-sct span.main-progress').css('height',total_retailcomp_cost+'px')
   }
  }
  if(!isNaN(credit_price) || !isNaN(retail_price) || !isNaN(total_cost_point)){
  $('a#pricing_tab').show();
  $('div#tab-1').show();
     $('.count').each(function() {
    var $this = $(this),
    countTo = $this.attr('data-count');
    $({
    countNum: $this.text()
    }).animate({
    countNum: countTo
    },
    {
    duration: 2000,
    easing: 'swing',
    step: function() {
      if(this.countNum != undefined){
      $this.text(Math.floor(this.countNum).toFixed(2));
      }
    },
    complete: function() {
      if(this.countNum != undefined || this.countNum > 0){
      $this.text(this.countNum.toFixed(2));
      }
    }
    });
    });
  }
  var Total_main_price1 = (parseInt(Total_main_price)-parseInt(total_cost_point))/10;
 if(Total_main_price > total_cost_point){
  if(Total_main_price1 >230){
    $('.left-side-sct span.main-progress').css('height','230px');
   }else{
  $('.left-side-sct span.main-progress').css('height',Total_main_price1+'px');
   }
 }
   
}
}
getdiamond_img(diamond_id)
async function loadInfoRing(){
    //allImage(); 

    let infoRing = JSON.parse(localStorage.getItem('wizardInfo'));    

    if (infoRing !=null || infoRing !=undefined) {
       var diamond_data = await diamind_data();
       var product_data = await getProductdata(infoRing.setting_product_handle);
    
       let currentCurrency = Shopify.currency.active;
       let currentCurrencySymbol = $('body').attr('data-currency');
       let currentRate = window.Shopify.currency.rate;
       
        let productId = $(product_data).find('.product_transprancy_pricing[data-id="'+infoRing.setting_variant_id+'"]').attr('p_id');
        let variantSku = $(product_data).find('.product_transprancy_pricing[data-id="'+infoRing.setting_variant_id+'"]').attr('v_sku');
       // loadProductImages(productId,variantSku,infoRing.stone_shape,infoRing.setting_selected_metal,infoRing.setting_selected_carat_size);

        let caratDiamond = toNumberFormat(diamond_data.Weight);
         let diamondPrice = toNumberFormat(diamond_data.Total_Price * currentRate);

        let caratSetting= toNumberFormat(diamond_data.Weight);
        let settingPrice= toNumberFormat(parseFloat($(product_data).find('.product_transprancy_pricing[data-id="'+infoRing.setting_variant_id+'"]').attr('p-without-m'))/100);
        let totalPrice = parseFloat(diamond_data.Total_Price * currentRate) + parseFloat($(product_data).find('.product_transprancy_pricing[data-id="'+infoRing.setting_variant_id+'"]').attr('p-without-m'))/100; 
        let ring_band_product = JSON.parse(localStorage.getItem('ring_band_product'));
        if(ring_band_product != null && ring_band_product != undefined){
         settingPrice = toNumberFormat(ring_band_product.ring_product_total_price);
         totalPrice = parseFloat(diamond_data.Total_Price * currentRate) + parseFloat(ring_band_product.ring_product_total_price); 
        } 
      totalPrice= toNumberFormat(totalPrice);     
       
        let totalCarat =diamond_data.Weight + infoRing.setting_selected_side_carat_weight;
        totalCarat=toNumberFormat(totalCarat);    
        let cutString = '';
        if(infoRing.stone_shape == 'Round'){
            cutString = `${infoRing.stone_cut} cut `;
        }
        document.getElementById('diamond-short-detail').innerHTML = `${caratDiamond} Carat  ${infoRing.stone_shape} Lab Grown Diamond `;
        document.getElementById('diamond_description').innerHTML = `${cutString} <span class="dot">•</span> ${infoRing.stone_color} Color <span class="dot">•</span> ${infoRing.stone_clarity}Clarity`
         document.getElementById('diamond-price').innerHTML = currentCurrencySymbol+''+diamondPrice; 

        let caratString = caratSetting>0?` with ${caratSetting} carats of diamonds.`:'';

        document.getElementById('setting-short-detail').innerHTML = `${infoRing.setting_selected_metal} ${infoRing.setting_product_name} ring ${caratString}`;
        document.getElementById('setting-price').innerHTML = currentCurrencySymbol+''+settingPrice;

        let extraTotalWeightString = caratSetting>0?' (includes center stone).':'.';
     
        //document.getElementById('ring-short-detail').innerHTML = `Your total diamond weight is ${totalCarat} carats of diamonds${extraTotalWeightString}`;
        document.getElementById('total-price').innerHTML = currentCurrencySymbol+''+totalPrice;

        let allowedRingSizes = infoRing.setting_allowed_ring_sizes.split(',');
        // Let's create the options for the select
        let selectSize = document.getElementById('select-size');
        allowedRingSizes.forEach((size)=>{
            let option = document.createElement('option');
            option.value = size;
            option.innerHTML = size;
            selectSize.appendChild(option);
        });
        
               // Let's validate if there's a diamond selected to be in stock and the diamond carat fits the setting carat
        if(infoRing.stone_carat && infoRing.setting_variant_id){
                if(infoRing.stone_carat < (parseFloat(infoRing.setting_min_carat_size)-0.10) || infoRing.stone_carat > (parseFloat(infoRing.setting_max_carat_size)+0.10) || infoRing.setting_allowed_shapes.includes(infoRing.stone_shape.split(" ")[0]) == false
                ){
                    document.getElementById('diamond-with-setting').style = 'display:none';
                    document.getElementById('noCTAInfo').innerHTML = `Sorry, your selected diamond doesn't fit in the ring, please choose another setting or diamond`;
                    document.getElementById('noCTAInfo').style = 'display:block';
                }
                else {
                    document.getElementById('diamond-with-setting').disabled = false;
                    document.getElementById('diamond-with-setting').innerHTML = 'ADD TO CART |' +currentCurrencySymbol+' '+totalPrice;
                }
            }
            else {
                if(infoRing.stone_carat && infoRing.stone_carat > 0){
                    if(!infoRing.setting_variant_id){
                        //There's no setting selected we need to direct the customer to the settings page
                        let caractDictValue = getCaratDictionaryValueForWizard(infoRing.stone_carat);
                        if(wizardInfo.stone_shape.toLowerCase().includes('cushion')){
                            wizardInfo.stone_shape = 'Cushion';
                        }
                        let shapeDictValue = 'dyo_shape_'+infoRing.stone_shape.toLowerCase();
                        window.location.href = '/collections/dyor-diamond-settings/'+caractDictValue+'+'+shapeDictValue;
                    }
                }
                else {
                    if(infoRing.setting_variant_id){
                        //There's no diamond selected we need to direct the customer to the diamonds page
                        window.location.href = '/collections/dyor-diamonds';
                    }
                    else {
                        //There's no diamond nor setting selected we need to direct the customer to the diamonds page
                        window.location.href = '/collections/dyor-diamonds?sw=d';
                    }
                }
            }
        

        

    }
}

loadInfoRing();
bindEvents();
function getdiamond_img(diamond_id){
    $(".complete_ring_stack").hide();
url = window.API_URL +`diamonds/apiservices/new_api/${diamond_id}`;
     fetch(url, {
        method: 'GET',        
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json()).then(async diamond => {
      
       get_sourcing_data(diamond.Seller_Name)
       if(diamond.Lab == "GIA"){
         $('.accordion-item-body-content .GAI_tab').show();
       }
       
      

        var custom_setting_certificate_image =`https://dsv7iunirnrax.cloudfront.net/gia_certificate/certificate_${diamond.Certificate_Number}.jpeg`;  
    
        if(diamond.Column81.indexOf('d=') > -1 || diamond.Column81.indexOf('surl=') > -1){
                   var Videourl=diamond.Column81;
               $(`#grid-img-diamond #diamond-img2,div#carouselExampleIndicators .carousel-inner .diamond-img2`).html(`<div class="main_container_first"><iframe data-scaling="true"  seamless="seamless" src="${Videourl}" scrolling="no" width=420 height=420></iframe></div>`);
               
              if(diamond.img_status == 1){
                  if(diamond.Image_URL){
                   $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<img src="${diamond.Image_URL}">`); 
                  } else{
                   $('#grid-img-diamond #diamond-img3').css('display', 'none');

                  }
                   
                 }  
                }
                else if(diamond.Column81.indexOf('.mp4') > -1){
                var video_mp4 = true
                var Videourl=diamond.Column81;
                $(`#grid-img-diamond #diamond-img2,div#carouselExampleIndicators .carousel-inner .diamond-img2`).html(`<video preload=metadata width="420" playsinline=""  height="420" autoplay  loop muted><source src="${Videourl}" type="video/mp4"> </video>`);  
                 if(diamond.img_status == 1){
                   $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID}.jpg">`);
                 }  
                }else if(diamond.Column81 !=''){
                    $(`#grid-img-diamond #diamond-img2,div#carouselExampleIndicators .carousel-inner .diamond-img2`).html(`<div class="main_container_first"><iframe src="${diamond.Column81}"  scrolling="no" width=420 height=420></iframe>`); 
                 if(diamond.img_status == 1){
                   $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID}.jpeg">`);
                 }  
                }else{
                  if(isV360(diamond.Image_URL)){
                    $(`#grid-img-diamond #diamond-img2,div#carouselExampleIndicators .carousel-inner .diamond-img2`).html(`<div class="main_container_first"><iframe src="${diamond.Image_URL}" scrolling="no" width=420 height=420></iframe></div>`);
                   if(diamond.img_status == 1){
                   $(`#grid-img-diamond #diamond-img3,div#carouselExampleIndicators .carousel-inner .diamond-img3`).html(`<img src="https://dsv7iunirnrax.cloudfront.net/first_image/diamond_${diamond.Diamond_ID}.jpeg">`);
                 }  
                  }
                }

                      /* here write code  complete ring code */

          let wizardInfo = JSON.parse(localStorage.getItem("wizardInfo"));
          let vendor =  diamond.Seller_Name;
          let rapnetPrice = parseFloat(diamond.rapent_price) || 0;
          let ringPrice = parseFloat(diamond.rapent_price);
          let stonePrice = parseFloat(diamond.total_sales_price);
          let diamondRetailerPrice = diamond.Retailer_Price || 0;
          let stockSku=diamond.Stock_Number;
          let material;
          let accentedStone;
          let labor;
          let logistic;
          let diamondLogistic;
          let setting_retailer_price =  parseFloat((wizardInfo.setting_retail_cost || "").trim()) || 0;
          let diamond_retailer_price =  parseFloat((localStorage.getItem("diamond_retail_price") || "").trim()) || 0;
          let duties_fee = parseFloat((localStorage.getItem("duties_price") || "").trim()) || 0;
          let vendor_url = window.API_URL + `diamonds/vendorPage/vendorShow/data`;

      $.ajax({
                url: vendor_url,
                method: 'GET',
                headers: {
                    'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM',
                },
                success: function (datas) {      
                    console.log(datas);
                    datas.forEach(function(item){
                        vendor = String(vendor)
                        .replace(/"/g, "")         
                        .replace(/\s+/g, " ")
                        .trim()
                        .toLowerCase();

                        diaVendor = String(item.vendor_name)
                        .replace(/"/g, "")         
                        .replace(/\s+/g, " ")
                        .trim()
                        .toLowerCase();
                        if(diaVendor == vendor){
                          console.log(`item.vendor_name==vendor ${item.vendor_name }  ${vendor}`)
                            let country = diamond.Country;
                            if(country && (country.toLowerCase() === "usa" || country.toLowerCase() === "united states" )){
                                diamondLogistic = item.logistics_usa;
                            } else {
                                diamondLogistic = item.logistics_international;
                            }     
                        }

                    });

                    if (wizardInfo) {
                      let showCompleteRing = localStorage.getItem("show_complete_ring") === "true";
                      if(showCompleteRing){
                          $(".complete_ring_stack").show();
                      }
                      else{
                          $(".complete_ring_stack").hide();
                      }
                      
                      material = parseFloat(wizardInfo.setting_material_cost)|| 0;
                      accentedStone = parseFloat(wizardInfo.setting_accented_cost)|| 0;
                      labor = parseFloat(wizardInfo.setting_labor_cost)|| 0;
                      logistic = parseFloat(wizardInfo.setting_logistic_cost)|| 0;
                      let settingPrice = parseFloat(wizardInfo.setting_variant_price)/100;
                      let totalVarPrice = parseFloat(settingPrice) + parseFloat(stonePrice);
                      diamondLogistic = Number(diamondLogistic).toFixed(2);
                     
                      let traditionalRetailPrice = 6000;
                      let totalSalesPrice = Number(diamond.total_sales_price);
                      diamondLogistic =Number(diamondLogistic) + 0.03 * totalSalesPrice;
                      let completeLogistic =  parseFloat(diamondLogistic) + parseFloat(logistic) || 0;
                      /* code here */
                        if(setting_retailer_price != 0 && diamond_retailer_price != 0){

                           traditionalRetailPrice = setting_retailer_price + diamond_retailer_price ;

                        }
                      /* code here*/



                      let variantSku = wizardInfo.setting_variant_sku
                      let twentyPercent = traditionalRetailPrice * 0.20;
                      let lowerPrice = traditionalRetailPrice - twentyPercent;
                      let upperPrice = traditionalRetailPrice + twentyPercent;

                      let ismaterialTitleBlank=$(".complete_pricing_title").data("material-title");
                      let isStoneTitleBlank=$(".complete_pricing_title").data("stone-title");
                      let isAccentedTitleBlank=$(".complete_pricing_title").data("accented-title");
                      let isLaborTitleBlank=$(".complete_pricing_title").data("labor-title");
                      let islogisticTitleBlank=$(".complete_pricing_title").data("logistic-title");

                     
// sahil sir agar mae kal nhi aya  17 Mar ko to ye ||rapnetPrice === 0 neeche wale if mae paste kar dena
                      if( ismaterialTitleBlank||isStoneTitleBlank||isAccentedTitleBlank||isLaborTitleBlank||islogisticTitleBlank ||material === 0 ||accentedStone === 0 ||labor === 0 ||
  completeLogistic === 0 ){
                       
                          $(".complete_ring_stack").hide();
                      }
                      else {

    
                      let formatter = new Intl.NumberFormat('en-US', {
                                style: 'currency',
                                currency: 'USD'
                      });
                      lowerPrice = formatter.format(lowerPrice);
                      upperPrice = formatter.format(upperPrice);
                      $(".complete_ring.manifest_sku").text(variantSku);
                      $(".complete_material_pricing #counter span").attr("data-count", material).text(material);
                      let manifest_material = formatter.format(material);
                      $(".complete_manifest_material").find(".count").text(manifest_material);

                      $(".complete_center_stone_pricing #counter span").attr("data-count", rapnetPrice).text(rapnetPrice);
                      let manifest_rapnetPrice = formatter.format(rapnetPrice);
                      $(".complete_manifest_center_stone").find(".count").text(manifest_rapnetPrice);
                      $(".complete_ring.center_stone_type").text(` ( ${stockSku} ) `);
                      $(".complete_accented_stone_pricing #counter span").attr("data-count", accentedStone).text(accentedStone);
                      let manifest_accented = formatter.format(accentedStone);
                      $(".complete_manifest_accented").find(".count").text(manifest_accented);

                      $(".complete_labor_pricing #counter span").attr("data-count", labor).text(labor);
                      let manifest_labor = formatter.format(labor);
                      $(".complete_manifest_labor").find(".count").text(manifest_labor);

                      $(".complete_logistic_pricing #counter span").attr("data-count", completeLogistic).text(completeLogistic);
                      let manifest_complete_logistic = formatter.format(completeLogistic);
                      $(".complete_manifest_logistic").find(".count").text(manifest_complete_logistic);
                      if(duties_fee == 0){
                        duties_fee = 0;
                         // $(".complete_duties_pricing").hide();
                         // $(".complete_manifest_duties").hide();
                         $(".complete_duties_pricing #counter span").attr("data-count", duties_fee).text(duties_fee);
                        let manifest_complete_duties = formatter.format(duties_fee);
                        $(".complete_manifest_duties").find(".count").text(manifest_complete_duties);
                      }
                      else{
                        $(".complete_duties_pricing #counter span").attr("data-count", duties_fee).text(duties_fee);
                        let manifest_complete_duties = formatter.format(duties_fee);
                        $(".complete_manifest_duties").find(".count").text(manifest_complete_duties);
                      }
                     


                       
                      let totalPrice = material + accentedStone + labor + completeLogistic + rapnetPrice + duties_fee;
                      let manifest_raw_price = formatter.format(totalPrice);
                      $(".complete_ring.ts ").find("span").text(manifest_raw_price);
                      
                      $(".complete_raw_asset").find(".count").text(manifest_raw_price);

                      let priceDiff = (totalVarPrice - totalPrice)
                      let protocolPercent = (priceDiff / totalVarPrice) * 100;
                      let finalTsPrice = totalPrice + priceDiff; 
                      finalTsPrice = finalTsPrice.toFixed(2);
                      let manifestTsPrice = formatter.format(finalTsPrice);
  
                      $(".complete_final_price").find(".count").text(manifestTsPrice);
                      
                      let manifestSaved = traditionalRetailPrice - totalVarPrice;
                      manifestSaved = manifestSaved.toFixed(2);

                      $(".complete_retail_manifest").text(traditionalRetailPrice);
                      $(".complete_saved_price_manifest").text(manifestSaved);
                      
                       $(".complete_ring_protocol").closest(".protocol_price").find(".protocol_percent").text(`(${Math.round(protocolPercent)}%)`);
                       $(".maifest_complete_protocol").find(".protocol_percent").text(`(${Math.round(protocolPercent)}%)`);
                       formatPriceDiff=priceDiff.toFixed(2);
                       $(".complete_ring_protocol").closest(".protocol_price").find("#counter span").attr("data-count", priceDiff).text(formatPriceDiff);
                       let manifest_price_diff = priceDiff.toFixed(2);
                       manifest_price_diff = formatter.format(manifest_price_diff);
                       $(".maifest_complete_protocol").find(".count").text(manifest_price_diff);

                      totalPrice=totalPrice.toFixed(2);
                      $(".complete_total_cost #counter span").attr("data-count", totalPrice).text(totalPrice);
                      $(".complete_final_ts #counter span").text(finalTsPrice);
                      $(".complete_compe_price .abs_low").text(lowerPrice);
                      $(".complete_compe_price .abs_upper").text(upperPrice);
                      let formattedMaterial = formatter.format(material);
                      let formattedAccentedStone = formatter.format(accentedStone);
                      let formattedLabor = formatter.format(labor);
                      let formattedLogistic = formatter.format(logistic);




                      /* truesanity graph height calculation */


                            // step 1
                            let totalCost = material+rapnetPrice+accentedStone+labor+completeLogistic;

                            // credit card fee (same liquid logic)
                            let ccFees = (totalVarPrice * 2.9) / 100;
                            let ccProcFees = parseFloat((ccFees + 0.3).toFixed(2));

                            // step 2
                            let finalTotalCost = totalCost + ccProcFees;

                            // step 3
                            let sanity = totalVarPrice;

                            // step 4
                            let sp = sanity - finalTotalCost;

                            // step 5
                            let spt = sp / sanity;

                            // step 6
                            let discountPercent = spt * 130;

                            // step 7 height logic
                            let height;

                            if (spt < 0) {
                            height = 0;
                            } 
                            else if (discountPercent > 160) {
                            height = 160;
                            } 
                            else {
                            height = discountPercent;
                            }
                           
                            totalVarPrice = formatter.format(totalVarPrice);
                            $(".complete_variant_price").text(totalVarPrice);
                            $(".complete-main-progress.truesanity").css("height", height + "px");



                      /* /* truesanity graph height calculation end */

                      /* traditional  graph height calculation */
                            let trad_total_without_cc = material+rapnetPrice+accentedStone+labor+completeLogistic;

                            // step 2: credit card fees
                            let trad_ccFees = (sanity * 2.9) / 100;
                            let trad_ccProcFees = parseFloat((trad_ccFees + 0.3).toFixed(2));

                            // step 3: total cost
                            let trad_total_cost = trad_total_without_cc + trad_ccProcFees;

                            // step 4: retail price

                            // step 5
                            let trad_sp = sanity - trad_total_cost;
                            let trad_spt = trad_sp / sanity;

                            let trad_rp = traditionalRetailPrice - trad_total_cost;
                            let trad_rpt = trad_rp / trad_total_cost;

                            // step 6
                            let trad_discount_percentk = trad_rpt * 130;

                            // step 7 height logic
                            let trad_height;

                            if (trad_discount_percentk < 0) {
                            trad_height = 0;
                            } 
                            else if (trad_discount_percentk > 160) {
                              
                                trad_height = 160;
                            } 
                            else {
                            trad_height = trad_discount_percentk;
                            }
                           
                            $(".complete-main-progress.retail").css("height", trad_height + "px");
                           
                            let traRetailPrice=formatter.format(traditionalRetailPrice)
                            $(".complete_ring.trad_title_cost").text(traRetailPrice);
                       /* traditional  graph height calculation end*/
                    }
                  }
                  }
        });
    })
         
}
function calcDeliveryDate(delivery_Date,qntymore,qntyless,price){ 
              var wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
              var stone_deliver = 0;
                if(wizardInfo != undefined && wizardInfo != null){
                if(wizardInfo.stone_delivery != undefined && wizardInfo.stone_delivery != null){
                stone_deliver = parseInt(wizardInfo.stone_delivery)
                }
                }
              var skipDates = $('.complete_ring').attr('data-exclued-date');
              var qnty_more_data = parseInt($('.complete_ring').attr('data-qty-more'));
              var qnty_less_data =  parseInt($('.complete_ring').attr('data-qty-less'));
              if(qntymore == undefined || qntymore == 0){
              var qnty_more_data = qnty_more_data;
              } else{
              var qnty_more_data = qntymore;  
              }  
              if(qntyless == undefined || qntyless == 0){
              var qnty_less_data = qnty_less_data;
              } else{
              var qnty_less_data = qntyless;  
              } 
              if(delivery_Date >= 1){
              if(qnty_more_data == 0){
              qnty_more_data_updated = qnty_more_data + 1;
              } else{
              qnty_more_data_updated = qnty_more_data;
              }          
              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
              ];
              let today = new Date();
              const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
              let hh = new Date(pstDate).getHours();
              if(hh > 15){
              var dd = today.getDate() + 1 ; 
              }  else{
              var dd = today.getDate();
              }
              if(stone_deliver > 0){
                dd = dd + stone_deliver
                if(dd>31){
                  dd = 31
                }
              }
              let mm = today.getMonth() + 1;
              let yyyy = today.getFullYear();
              var startDate = yyyy + '/' + mm + '/' + dd;
              startDate = new Date(startDate);
              var endDate = "";
              var noOfDaysToAdd = qnty_more_data_updated;
              var count = 0;
              while(count < noOfDaysToAdd){
              endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
              if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
              continue;
              }
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
              count++;
              }
              }
              const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];   
              var country_loc = localStorage.getItem("countryus");
              
              if(country_loc == "yes") {
              if(price < 250 ){  
              var newDate =  new Date(endDate.getTime() + (3 * 86400000));
              var newDate2 = new Date(endDate.getTime() + (6 * 86400000));
              if(qnty_less_data == 0){
              var newdd = newDate.getDate()- 1;
              var newddrange = newDate2.getDate();
              } else{
              var newdd = newDate.getDate();
              var newddrange = newDate2.getDate();
              }
              var newmm = newDate.getMonth() + 1;
              
              if(qnty_less_data == 0){
              var dayrange = weekday[newDate2.getDay()];
              var day = weekday[newDate.getDay() -1];
              } else{
              var dayrange = weekday[newDate2.getDay()];
              var day = weekday[newDate.getDay()];
              }
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayrange+', '+monthNames[newDate2.getMonth()] + ' ' +newddrange;
              } else{

              var newDate =  new Date(endDate.getTime() + (2 * 86400000));
              if(qnty_less_data == 0){
              var newdd = newDate.getDate()- 1;
              
              } else{
              var newdd = newDate.getDate();
              }
              var newmm = newDate.getMonth() + 1;
              if(qnty_less_data == 0){
              var day = weekday[newDate.getDay() -1];
              } else{
              var day = weekday[newDate.getDay()];
              }
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
              }
              } else{                   var newDate =  new Date(endDate.getTime());
              if(qnty_less_data == 0){
              var newdd = newDate.getDate()- 1; 
              } else{
              var newdd = newDate.getDate();  
              }
              if(qnty_less_data == 0){
              var day = weekday[newDate.getDay() -1];
              } else{
              var day = weekday[newDate.getDay()];
              } 
              var newmm = newDate.getMonth() + 1;
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd;
              }
              var text = document.createTextNode(finalDate).textContent;
              document.getElementById('est_delivery_date').innerHTML = text;    
              document.getElementById('delivery_date').value = text; 
              } else if(delivery_Date < 1){
              if(qnty_less_data == 0){
              qnty_less_data_updated = parseInt(qnty_less_data) + 1;
              } else{
              qnty_less_data_updated = qnty_less_data;
              }
              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
              ];
              let today = new Date();
              const pstDate = today.toLocaleString("en-US", { timeZone: "America/New_York" });
              let hh = new Date(pstDate).getHours();
              if(hh > 15){
              if(qnty_less_data == 0){
              var dd = today.getDate() + 1 ; 
              } else{
              var dd = today.getDate() + 2 ;  
              }
              }  else{
              if(qnty_less_data == 0){
              var dd = today.getDate(); 
              } else{
              var dd = today.getDate() + 1 ;  
              }
              }
                if(stone_deliver > 0){
                dd = dd + stone_deliver
                  if(dd>31){
                  dd = 31
                }
              }
              let mm = today.getMonth() + 1;
              let yyyy = today.getFullYear();
              var startDate = yyyy + '/' + mm + '/' + dd;
              startDate = new Date(startDate);
              var startDateRange = yyyy + '/' + mm + '/' + dd;
              startDateRange = new Date(startDateRange);
              var startDateOUtUs = yyyy + '/' + mm + '/' + dd;
              startDateOUtUs = new Date(startDateOUtUs); 
              var endDate = "";
              var endDateoutus = "";
              var endDateRange = "";
              var country_loc = localStorage.getItem("countryus");
              if(country_loc == 'yes'){
              if(price < 251 ){
              if(qnty_less_data == 0){
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ; 
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
              } else{
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 3 ; 
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 6 ; 
              }  
              } else{
              if(qnty_less_data == 0){
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 1 ;
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 4 ; 
              } else{
              var noOfDaysToAdd = parseInt(qnty_less_data_updated) + 2 ;
              var noOfDaysToAddrange = parseInt(qnty_less_data_updated) + 5 ; 
              }   
              }  
              } else{
              if(qnty_less_data == 0){
              var noOfDaysToAddoutusa = parseInt(qnty_less_data_updated) + 1;  
              } else{
              var noOfDaysToAddoutusa = qnty_less_data_updated; 
              }   
              }
              var countoutus = 0;
              while(countoutus < noOfDaysToAddoutusa ){
              endDateoutus = new Date(startDateOUtUs.setDate(startDateOUtUs.getDate() + 1)); 
              if (skipDates.includes(endDateoutus.toISOString().substring(0, 10))) {
              continue;
              }
              if (endDateoutus.getDay() != 0 && endDateoutus.getDay() != 6 &&  !skipDates.includes(startDateOUtUs.toISOString().substring(0, 10))) {
              countoutus++;
              }
              }
              var count = 0;
              while(count < noOfDaysToAdd ){
              endDate = new Date(startDate.setDate(startDate.getDate() + 1)); 
              if (skipDates.includes(endDate.toISOString().substring(0, 10))) {
              continue;
              }
              if (endDate.getDay() != 0 && endDate.getDay() != 6 &&  !skipDates.includes(startDate.toISOString().substring(0, 10))) {
              count++;
              }
              }
              var count1 = 0;
              while(count1 < noOfDaysToAddrange ){
              endDateRange = new Date(startDateRange.setDate(startDateRange.getDate() + 1)); 
              if (skipDates.includes(endDateRange.toISOString().substring(0, 10))) {
              continue;
              }
              if (endDateRange.getDay() != 0 && endDateRange.getDay() != 6 &&  !skipDates.includes(startDateRange.toISOString().substring(0, 10))) {
              count1++;
              }
              }
              const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]; 
              var country_loc = localStorage.getItem("countryus");
              if(country_loc == "yes") {
              var newDateRange =  new Date(endDateRange.getTime());
              var newDaten =  new Date(endDateRange.getTime() + (1 * 86400000));
              var skipDates = $('.complete_ring').attr('data-exclued-date');
              var dateString = newDaten.toISOString().slice(0, 10);
              if (skipDates.includes(dateString)) {
              var newDateRange =  new Date(endDateRange.getTime() + (1 * 86400000));
              var newDatett =  new Date(endDateRange.getTime() + (2 * 86400000));   
              var dateString2 = newDatett.toISOString().slice(0, 10);
              if (skipDates.includes(dateString2)) {
              var newDateRange =  new Date(endDateRange.getTime() + (2 * 86400000));
              var newDatettt =  new Date(endDateRange.getTime() + (3 * 86400000));
              var dateString3 = newDatettt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString3)) {
              var newDateRange =  new Date(endDateRange.getTime() + (3 * 86400000));
              var newDatettttt =  new Date(endDateRange.getTime() + (4 * 86400000));
               var dateString4 = newDatettttt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString4)) {
              var newDateRange =  new Date(endDateRange.getTime() + (4 * 86400000));
              }  
              }
              }
              }
              
              var newDate =  new Date(endDate.getTime());
              var newDaten =  new Date(endDate.getTime() + (1 * 86400000));
              var skipDates = $('.complete_ring').attr('data-exclued-date');
              var dateString = newDaten.toISOString().slice(0, 10);
              if (skipDates.includes(dateString)) {
              var newDate =  new Date(endDate.getTime() + (1 * 86400000));
              var newDatett =  new Date(endDate.getTime() + (2 * 86400000));   
              var dateString2 = newDatett.toISOString().slice(0, 10);
              if (skipDates.includes(dateString2)) {
              var newDate =  new Date(endDate.getTime() + (2 * 86400000));
              var newDatettt =  new Date(endDate.getTime() + (3 * 86400000));
              var dateString3 = newDatettt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString3)) {
              var newDate =  new Date(endDate.getTime() + (3 * 86400000));
              var newDatettttt =  new Date(endDate.getTime() + (4 * 86400000));
               var dateString4 = newDatettttt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString4)) {
              var newDate =  new Date(endDate.getTime() + (4 * 86400000));
              }  
              }
              }
              }
              var newddRange = newDateRange.getDate();
              var newmmRange = newDateRange.getMonth() + 1;
              let dayRange = weekday[newDateRange.getDay()];
              var newdd = newDate.getDate();
              var newmm = newDate.getMonth() + 1;
              let day = weekday[newDate.getDay()];
              if(newdd == "1" || newdd == "21" || newdd == "31"){
              var dayt = newdd+'st';
              } else if(newdd == "2" || newdd == "22"){
               var dayt = newdd+'nd';
              } else if(newdd == "3" || newdd == "33"){
              var dayt = newdd+'rd';
              } else{
              var dayt = newdd+'th';
              }
              if(newddRange == "1" || newddRange == "21" || newddRange == "31"){
              var daytrange = newddRange+'st';
              } else if(newddRange == "2" || newddRange == "22"){
               var daytrange = newddRange+'nd';
              } else if(newddRange == "3" || newddRange == "33"){
              var daytrange = newddRange+'rd';
              } else{
              var daytrange = newddRange+'th';
              }
              if(price < 251 ){
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd +' - '+dayRange+', '+monthNames[newDateRange.getMonth()] + ' ' +daytrange;
              } else{
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +dayt ;
              }  
              var text = document.createTextNode(finalDate);
              var text = document.createTextNode(finalDate).textContent;
             
              document.querySelector('#deliverydate').innerHTML = text;
              document.querySelector('#est_ship').innerHTML = text;
              } else{
              var newDate =  new Date(endDateoutus.getTime());
              var newDaten =  new Date(endDateoutus.getTime() + (1 * 86400000));
              var skipDates = $('.complete_ring').attr('data-exclued-date');
              var dateString = newDaten.toISOString().slice(0, 10);
              if (skipDates.includes(dateString)) {
              var newDate =  new Date(endDateoutus.getTime() + (1 * 86400000));
              var newDatett =  new Date(endDateoutus.getTime() + (2 * 86400000));   
              var dateString2 = newDatett.toISOString().slice(0, 10);
              if (skipDates.includes(dateString2)) {
              var newDate =  new Date(endDateoutus.getTime() + (2 * 86400000));
              var newDatettt =  new Date(endDateoutus.getTime() + (3 * 86400000));
              var dateString3 = newDatettt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString3)) {
              var newDate =  new Date(endDateoutus.getTime() + (3 * 86400000));
              var newDatettttt =  new Date(endDateoutus.getTime() + (4 * 86400000));
               var dateString4 = newDatettttt.toISOString().slice(0, 10);
              if (skipDates.includes(dateString4)) {
              var newDate =  new Date(endDateoutus.getTime() + (4 * 86400000));
              }  
              }
              }
              }
              var newdd = newDate.getDate();
              var newmm = newDate.getMonth() + 1;
              let day = weekday[newDate.getDay()];
              if(newdd == "1" || newdd == "21" || newdd == "31"){
              var dayt = newdd+'st';
              } else if(newdd == "2" || newdd == "22"){
               var dayt = newdd+'nd';
              } else if(newdd == "3" || newdd == "33"){
              var dayt = newdd+'rd';
              } else{
              var dayt = newdd+'th';
              }
              var finalDate = day+', '+monthNames[newDate.getMonth()] + ' ' +newdd ;
              }
              var endDateSpecial = $('.end_date_sp').text();
              var startDateSpecial = $('.start_date_sp').text();
              const date2 = new Date(endDateSpecial);
              const date1 = new Date(startDateSpecial);
              const date3 = new Date(newDate);
              const date4 = new Date(newDateRange);
              if(country_loc == "yes") {  
              if(price < 251 ){
              if (date4 > date1 && date4 <= date2) {
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'flex';
              document.getElementById('special_ocassion_id').value = '1';
              }
              } else{
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'none';
              document.getElementById('special_ocassion_id').value = '0'; 
              }
              }
              } else{
              if (date3 > date1 && date3 <= date2) {
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'flex';
              document.getElementById('special_ocassion_id').value = '1';
              }
              } else{
              if(document.getElementById('special_ocassion') != null){
              document.getElementById('special_ocassion').style.display = 'none';
              document.getElementById('special_ocassion_id').value = '0'; 
              }
              }
              }  
              }              
              var text = document.createTextNode(finalDate).textContent;
               document.querySelector('#deliverydate').innerHTML = text;
               document.querySelector('#est_ship').innerHTML = text;
               } 
              }
function isV360(url){
    if(url.indexOf('360') > -1){
        return true;
    }
    else{
        return false;
    }
}

function get_sourcing_data(vendor) {
   var product_vendor = wizardInfo.setting_vendor;
   fetch(window.API_URL+`diamonds/apiservices/new_api/vendorPage/multipleVendordata/${vendor},${product_vendor}`, {
      method: 'GET',
      headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
      }).then(res => res.json())
      .then(response => {
         sourcing_cal(response);
      });
}
function sourcing_cal(response){
setTimeout(function(){

if(response != undefined && response[0].duties_freight_handling == '' && response[0].packaging == '' && response[0].source_components_percentage == '' && response[0].source_components_weightage == '' ){
$('div#tab-4').hide();
$('a#sourcing_ultra').hide();
if($('#pricing_tab:visible').length == 0){
$('a#manf_tab').addClass('active');
$('div#tab-2').show();
}
}
else{
if($('#pricing_tab:visible').length == 0){
$('div#tab-4').show();
$('a#sourcing_ultra').addClass('active');
}
}
},800)

var source_components_percentage = 0;
var source_components_weightage = 0;
var source_crafting_cost_percentage = 0;
var source_crafting_cost_weightage = 0;
var source_packaging_percentage = 0;
var source_packaging_weightage = 0;
$(response).each(function(){
source_components_percentage = source_components_percentage+parseInt(this.source_components_percentage);
source_components_weightage = source_components_weightage+parseInt(this.source_components_weightage);
source_crafting_cost_percentage = source_crafting_cost_percentage+parseInt(this.source_crafting_cost_percentage);
source_crafting_cost_weightage = source_crafting_cost_weightage+parseInt(this.source_crafting_cost_weightage);
source_packaging_percentage = source_packaging_percentage+parseInt(this.source_packaging_percentage);
source_packaging_weightage = source_packaging_weightage+parseInt(this.source_packaging_weightage);
})
$('div#tab-4 .components_percentage .Prg_tab_bar_inner_color').css('width',source_components_percentage+'%');
$('div#tab-4 .components_percentage p.prg_bar_total_percent').text(source_components_percentage+'%');
$('div#tab-4 .crafting_cost .Prg_tab_bar_inner_color').css('width',source_crafting_cost_percentage+'%');
$('div#tab-4 .crafting_cost p.prg_bar_total_percent').text(source_crafting_cost_percentage+'%');
$('div#tab-4 .pckaging .Prg_tab_bar_inner_color').css('width',source_packaging_percentage+'%');
$('div#tab-4 .pckaging p.prg_bar_total_percent').text(source_packaging_percentage+'%');
var components_percentage = (source_components_percentage*source_components_weightage)/100;
var crafting_percentage = (source_crafting_cost_percentage*source_crafting_cost_weightage)/100;
var packagin_percentage = (source_packaging_percentage*source_packaging_weightage)/100;
$('div#tab-4 .sourcing_tab1_content  h3').text(components_percentage+'% Overall Traceability');
$('div#tab-4 .sourcing_tab2_content  h3').text(crafting_percentage+'% Overall Traceability');
$('div#tab-4 .sourcing_tab3_content  h3').text(packagin_percentage+'% Overall Traceability')
}
$('#select-size').change(function(){
$('#selected_value_error').hide();
})
function checkImageExists(imageUrl, callback) {
    var img = new Image();
    img.onload = function() {
        // The image loaded successfully
        callback(true);
    };
    img.onerror = function() {
        // The image could not be loaded
        callback(false);
    };
    img.src = imageUrl;
}

history.pushState(history.pushState({urlPath:path},"",path))